import React from 'react';

const CardViewShimmer = () =>
{
	return (
		<div className='flexCol pdngHMD'>
			<div className='mediaImageHeight pdngXS'>
				<div className='mediaKitCardShimmer brdrRadiusSM'>
					<div className='mediaKitCardshimmerBG mediaImageHeight' />
				</div>
			</div>
		</div>
	);
};

export default CardViewShimmer;
